var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['filter', _vm.classes]},[_c('div',{staticClass:"header",on:{"click":function($event){return _vm.toggle($event)}}},[_c('h3',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_vm._v(" "),_c('span',{staticClass:"mdi mdi-chevron-down"})]),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bea6c41","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Filter.vue
// module id = null
// module chunks = 